import React, { useEffect, useState, useRef } from "react";
import { GoogleMap, useJsApiLoader, StandaloneSearchBox } from '@react-google-maps/api';
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { popularProfessional } from "../../redux/slices/SearchFilterSlice";
import PopularProfessionalCard from "./PopularProfessionalCard";
import { Link } from "react-router-dom";

const PopularProfessional = () => {

  const user = useSelector(state => state?.AuthSlice?.user)
  const userRole = user?.role?.name;

  const [homePageLocation, setHomePageLocation] = useState({
    address: "United States",
    latitude: "31.5313",
    longitude: "74.3183",
  })

  // GOOGLE MAP API
  const inputRef = useRef(null);
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
    libraries: ["places"]
  });

  const handlePlacesChange = () => {
    const places = inputRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setCoordinates({ lat, lng });
      setHomePageLocation({
        address: places[0].formatted_address,
        longitude: lng,
        latitude: lat
      })
    }
  };
  // GOOGLE MAP API

  const dispatch = useDispatch();
  const professionals = useSelector((state) => state.SearchFilterSlice.popularProfessionals);
  // const loading = useSelector(state => state?.SearchFilterSlice?.loading)
  const [btnLoading, setBtnLoading] = useState(false)
  const [defaultLocationChange, setDefaultLocationChange] = useState("United States")

  useEffect(() => {
    popularProfessionalHandler()
  }, [])

  const popularProfessionalHandler = async () => {
    setBtnLoading(true)
    console.log(homePageLocation, "address");
    const res = await dispatch(popularProfessional(homePageLocation));
    if (res.payload.status === 200) {
      setBtnLoading(false)
      setDefaultLocationChange(homePageLocation?.address)
    }
    console.log(res);
  };

  return (
    <>
      <div className="popular-professionals-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="home-banner-text">
                <h1 className="mb-4">Search Verified Professionals In Town</h1>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            {isLoaded && (
              <div className="col-md-12">
                <div className="professional-search-box-home">
                  <StandaloneSearchBox onLoad={(ref) => inputRef.current = ref} onPlacesChanged={handlePlacesChange}>
                    <input type="text" className='home-banner-search' placeholder='Search I-Sit' name="" id="" />
                  </StandaloneSearchBox >

                  <button className="btn btn-primary btn-box-home" disabled={btnLoading} onClick={popularProfessionalHandler}>
                    {!btnLoading ? "Find" : <i
                      style={{ fontSize: "22px" }}
                      className="fa-solid fa-spinner fa-spin"
                    ></i>}
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        <div className="popular-professional-box">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1 className="home-main-heading">Verified Professionals In</h1>
                <p className="common-text">
                  <i className="fa-solid fa-location-dot"></i> {defaultLocationChange}
                </p>
              </div>

              <div className="col-md-12">
                {professionals?.data?.length > 0 ? <div className="popular-card-box">
                  {professionals &&
                    professionals?.data?.map((professional, index) => (
                      <Link to={`/service/provider/${professional?.id}`} key={index} style={{
                        pointerEvents: userRole === "user" ? "auto" : "none",
                        opacity: userRole === "user" ? 1 : 0.7,
                        cursor: userRole === "user" ? "pointer" : "not-allowed",
                      }}>
                        <PopularProfessionalCard professional={professional} />
                      </Link>
                    ))}
                </div> : <div className="no-data-found-box-homepage">
                  <img src="/images/No-data-cuate.png" alt="No Data Found" />
                  <h2>No Data Found</h2>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularProfessional;
